import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import '@fontsource/cormorant-garamond/300.css';
import '@fontsource/cormorant-garamond/400.css';
import '@fontsource/cormorant-garamond/500.css';
import './index.css';
import App from './App';

// ===== Axios global interceptors =====
// 1. Sempre anexa o token salvo no Authorization header
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 2. Em 401 em rotas autenticadas, limpa o storage e redireciona para o login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    const isLoginCall = url.includes('/api/auth/login') || url.includes('/api/auth/signin') || url.includes('/api/auth/register');
    if (status === 401 && !isLoginCall) {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('tenant');
      } catch (_) {}
      const path = window.location.pathname || '';
      if (!path.includes('/login')) {
        // Vai para a tela de login do CRM
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

// 3. Validação inicial: se temos token mas /api/auth/me retorna 401, limpa tudo antes de montar o app.
const _bootstrap = async () => {
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    const backend = process.env.REACT_APP_BACKEND_URL || '';
    const r = await fetch(`${backend}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
      cache: 'no-store',
    });
    if (r.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('tenant');
    }
  } catch (_) {
    // ignore – deixa o app montar normalmente
  }
};

_bootstrap().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
